<template lang="pug">
v-container(fluid class="tw-pa-0 tw-ma-0 tw-h-screen tw-overflow-y-auto tw-pb-10 tw-mb-10")
  v-row(no-gutters align="center")
    v-col(cols="auto")
      v-avatar(size="56" color="indigo lighten-4" class="tw-border-indigo-600 tw-border-solid tw-border-2")
        span(class="tw-font-bold tw-text-2xl tw-text-white") {{ contact.name.charAt(0).toUpperCase() }}{{ contact.last_name.charAt(0).toUpperCase() }}
    v-col(class="pl-4")
      v-row(no-gutters)
        v-col(class="pb-1")
          span(class="tw-text-2xl tw-font-semibold tw-text-gray-700 tw-capitalize") {{ contact.name }} {{ contact.last_name }}
      v-row(no-gutters)
        v-col(v-if="contact.phone" cols="auto" class="pr-2")
          v-icon(small class="pb-1") mdi-phone-classic
          span(class=" pl-1") {{ contact.phone }}
        v-col(v-if="contact.email" cols="auto")
          v-icon(small class="pb-1") mdi-email
          span(class=" pl-1") {{ contact.email }}
    v-col(cols="auto")
      v-btn(outlined color="indigo" @click="editDialogToggle")
        span(class="tw-font-bold") {{ $t('Common.edit') }}

  v-row(dense v-if="contact.address_country || contact.address_city || contact.address_street")
    v-col
      v-icon mdi-map-marker
      span {{ contact.address_street }}
      span(v-if="contact.address_street_number" class="pl-1") \#{{ contact.address_street_number }}
      span(v-if="contact.address_extended_address") , {{ contact.address_extended_address }}
      span(v-if="contact.address_city") , {{ contact.address_city }}
      span(v-if="contact.address_zip_code" class="pl-1") {{ contact.address_zip_code }}
      span(v-if="contact.address_country" class="pl-1") {{ contact.address_country }}
  v-row(dense)
    v-col
      kubiqa-contacts-contact-related-items(:contact="contact.id" :key="contact.id")

  div(class=" tw-flex tw-flex-grow tw-max-h-full tw-h-full tw-pb-4 ")
    v-row(no-gutters class="tw-max-h-full  d-flex flex-row flex-grow-1 ")
      v-col(class=" d-flex flex-column flex-grow-1 overflow-hidden")

  v-dialog(v-model="editDialog" width="40%" :fullscreen="!$vuetify.breakpoint.mobile ? false : true" max-width="40%")
    div(class="tw-bg-white edit-dialog")
      kubiqa-contacts-edit-main(:key="mKey" @close="editDialogToggle")
</template>

<script>
export default {
  props: {
    contactId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      editDialog: false,
      mKey: 1,
    };
  },
  computed: {
    contact() {
      return this.$store.getters['contacts/current_contact'];
    },
  },
  methods: {
    openListing(item) {
      this.$router.push('/listing/' + item);
    },
    editDialogToggle() {
      this.mKey = ++this.mKey;
      return (this.editDialog = !this.editDialog);
    },
  },
};
</script>
<style lang="stylus" scoped>
.edit-dialog
    height: 87vh
    max-height: 660px
</style>
